import React from 'react'

export default function CleartripLogo({ width = 16, height = 16 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 4.72939C12.3531 7.39606 9.20792 10.8971 6.39534 13.8351C6.18819 14.0423 5.91686 14.1882 5.6251 14.1882C5.27207 14.1882 5.00074 13.981 4.74983 13.6047C4.02042 12.5222 2.91758 9.89645 2.41577 8.7498C2.01897 7.8133 2.22904 7.04012 3.16557 6.64624C4.10211 6.26987 5.1437 6.2086 5.39461 7.2706C5.39461 7.2706 5.87309 9.12615 6.01897 9.66593C8.91614 6.97885 12.4785 4.12546 15.4982 2.37491C14.7484 0.956963 13.2692 0 11.5828 0H4.43764C1.97812 0 0 1.97811 0 4.41721V11.5828C0 14.0189 1.97812 16 4.43764 16H11.5828C14.019 16 16 14.0219 16 11.5828V4.72939Z" fill="#FF4F17" />
        </svg>
    )
}
